import { render, staticRenderFns } from "./commissionForm.vue?vue&type=template&id=52c900cd&scoped=true"
import script from "./commissionForm.vue?vue&type=script&lang=js"
export * from "./commissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c900cd",
  null
  
)

export default component.exports